import { string } from "yup"

// Opportunity fields added for the filters, shared by every opportunity form.
// Nothing here is required, so existing opportunities save without them.

const LIST_FIELDS = [
  "eligibility",
  "business_functions",
  "geographic_eligibility",
]
const AMOUNT_PATTERN = /^\d{1,13}(\.\d{1,2})?$/
const DEFAULT_STATUS = "open"

const toAmount = (value) =>
  value === null || value === undefined ? "" : String(value)

export const criteriaInitialValues = (data = {}) => ({
  ...Object.fromEntries(LIST_FIELDS.map((name) => [name, data[name] || []])),
  value_min: toAmount(data.value_min),
  value_max: toAmount(data.value_max),
  status: data.status || DEFAULT_STATUS,
})

const amount = (label) =>
  string().matches(AMOUNT_PATTERN, {
    message: `Please enter a valid ${label} amount (numbers only)`,
    excludeEmptyString: true,
  })

export const criteriaValidation = {
  value_min: amount("minimum"),
  value_max: amount("maximum").test({
    name: "value_range",
    message: "Maximum value should be greater than or equal to the minimum",
    test(max) {
      const min = this.parent.value_min
      if (!max || !min) return true
      return Number(max) >= Number(min)
    },
  }),
}

/** Multipart forms can't send arrays, so lists are sent comma separated. */
export const serializeCriteria = (values) => ({
  ...values,
  ...Object.fromEntries(
    LIST_FIELDS.map((name) => [name, (values[name] || []).join(",")]),
  ),
})
